import { render, staticRenderFns } from "./MbTestWithPoints.vue?vue&type=template&id=19547640&scoped=true&"
import script from "./MbTestWithPoints.vue?vue&type=script&lang=js&"
export * from "./MbTestWithPoints.vue?vue&type=script&lang=js&"
import style0 from "./MbTestWithPoints.vue?vue&type=style&index=0&id=19547640&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19547640",
  null
  
)

export default component.exports